import Vue from 'vue'

import {numberFormat,formatDateTime,changePhone} from '@/utils/index'


Vue.filter("formatDate", formatDateTime);
Vue.prototype.formatDate = formatDateTime;

// 价格格式转换
Vue.filter("numberFormat", numberFormat)


//通过时间过去星期

Vue.filter("formatDay", function formatDay(str) {
  if (str) {
    let weekDay = new Date(str).getDay();
    if (weekDay === 1) {
      return "星期一"
    } else if (weekDay === 2) {
      return "星期二"
    } else if (weekDay === 3) {
      return "星期三"
    } else if (weekDay === 4) {
      return "星期四"
    } else if (weekDay === 5) {
      return "星期五"
    } else if (weekDay === 6) {
      return "星期六"
    } else if (weekDay === 0) {
      return "星期天"
    }
  }
})
//数字补零
Vue.filter("toDecimal", function toDecimal(x) {
  if (x === 0 || x === undefined || x === null) {
    return '0.00'
  }
  let f = Math.round(x * 100) / 100;
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;

});
//时间戳转换带上时间
Vue.filter("formatDateTime", formatDateTime);

Vue.filter("changPhone",changePhone );

Vue.filter('numberID', function numberID(numberID) {
  if (numberID < 10) {
    return '0000' + numberID;
  } else if (numberID < 100) {
    return '000' + numberID;
  } else if (numberID < 1000) {
    return '00' + numberID;
  } else if (numberID < 10000) {
    return '0' + numberID;
  } else {
    return numberID;
  }
})





// WEBPACK FOOTER //
// ./src/filters/index.js